import { render, staticRenderFns } from "./NewDocumentModalContent.vue?vue&type=template&id=44bcd11d&scoped=true&"
import script from "./NewDocumentModalContent.vue?vue&type=script&lang=js&"
export * from "./NewDocumentModalContent.vue?vue&type=script&lang=js&"
import style0 from "./NewDocumentModalContent.vue?vue&type=style&index=0&id=44bcd11d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bcd11d",
  null
  
)

export default component.exports